import { useNavigate, useLocation } from 'react-router-dom';
import { Home, BookOpen, Building2, CalendarDays, Library, User, Settings, LogIn } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

export default function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user } = useAuth();
  const roles = user?.roles || [user?.role];
  const items = [
    { id: 'home', icon: Home, label: 'Home', path: '/' },
    ...(user ? [{ id: 'dashboard', icon: BookOpen, label: 'Courses', path: '/dashboard' }] : []),
    { id: 'branches', icon: Building2, label: 'Branches', path: '/branches' },
    { id: 'events', icon: CalendarDays, label: 'Events', path: '/events' },
    ...(user ? [
      { id: 'library', icon: Library, label: 'Library', path: '/library' },
      { id: 'profile', icon: User, label: 'Profile', path: '/profile' },
    ] : [{ id: 'auth', icon: LogIn, label: 'Sign in', path: '/auth' }]),
  ];
  if (roles.includes('admin')) items.push({ id: 'admin', icon: Settings, label: 'Admin', path: '/admin' });
  else if (roles.includes('manager')) items.push({ id: 'manager', icon: Settings, label: 'Manage', path: '/manager' });
  else if (roles.includes('teacher')) items.push({ id: 'teacher', icon: Settings, label: 'Teach', path: '/teacher' });

  const isActive = (p) => (p === '/' ? pathname === '/' : pathname.startsWith(p));
  return (
    <nav className="fixed bottom-0 inset-x-0 z-50 bg-[#0D0B1B]/95 backdrop-blur-2xl border-t border-[#8B5CF6]/20 shadow-[0_-10px_30px_rgba(0,0,0,0.7)] pb-safe" data-testid="bottom-nav">
      <div className="flex items-center justify-between sm:justify-center sm:gap-3 overflow-x-auto no-scrollbar max-w-2xl mx-auto px-1.5 py-1.5">
        {items.map(item => {
          const active = isActive(item.path);
          return (
            <button key={item.id} onClick={() => navigate(item.path)} data-testid={`nav-${item.id}`}
              className={`relative flex flex-col items-center justify-center shrink-0 min-w-[50px] px-1.5 py-1 rounded-xl transition-[color,background-color,transform] duration-200 ${active ? 'text-[#FBBF24] bg-[#2A1747]/60 scale-105' : 'text-[#8A8AA0] hover:text-[#FBBF24]'}`}>
              {active && <span className="absolute -top-1.5 h-0.5 w-6 rounded-full bg-gradient-to-r from-[#EF4444] via-[#8B5CF6] to-[#F59E0B]" />}
              <item.icon size={19} strokeWidth={1.75} />
              <span className="text-[10px] font-medium mt-0.5 whitespace-nowrap leading-tight">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
